import React from 'react';
import styled from "styled-components";
import { Atom } from 'AppReact';


const Template = styled.div`
    overflow: auto;
    height: calc(100vh - 250px);
`

const customTemplate = () => <Template dangerouslySetInnerHTML={{ __html: window.PROPERTY_TERMS }}/>
 
export default Atom({ type: 'custom', dataType: 'string', template: customTemplate})
